var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('SliderComponents',{staticStyle:{"z-index":"5"}}),_c('WeAreSectionComponent'),_c('VisionComponent'),_c('OurPartnersHomeSection'),_c('StaticsComponent'),_c('ServicesSectionComponent'),_c('OurProjects'),_c('div',{staticClass:"respirator"}),_c('ContactInfoComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }